/** NEW-CODE-BELOW, ADDING BECAUSE WHEN TAB CLOSE AND COME AFTER SOMETIME OR NEXT DAY IT WILL LOGOUT DUE TO IN ACTIVITY */
import { useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { USER_LOGOUT } from "../action/Action";

const IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
// const IDLE_TIMEOUT_MS = 20 * 1000; // 20 seconds (testing)
const LAST_ACTIVITY_KEY = "lastActivityTime";

const useIdleLogout = (isAuthenticated: boolean) => {
  const timerRef = useRef<number | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = useCallback(() => {
    // console.log("---LOGOUT CALLED---");

    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    localStorage.removeItem(LAST_ACTIVITY_KEY);
    localStorage.removeItem("token");   // 🔥 IMPORTANT

    dispatch({ type: USER_LOGOUT });
    navigate("/login", { replace: true });

  }, [dispatch, navigate]);

  // 🔥 Update activity timestamp
  const updateLastActivity = useCallback(() => {
    localStorage.setItem(LAST_ACTIVITY_KEY, Date.now().toString());
  }, []);

  // 🔥 Reset timer (live tab protection)
  const resetTimer = useCallback(() => {
    // console.log('---insideResetTimer---');
    
    if (!isAuthenticated) return;

    // console.log("----Timer Reset at:", new Date().toLocaleTimeString());

    updateLastActivity();

    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }

    timerRef.current = window.setTimeout(() => {
      // console.log("---TIMER FINISHED");
      logout();
    }, IDLE_TIMEOUT_MS);

  }, [isAuthenticated, logout, updateLastActivity]);

  useEffect(() => {
    if (!isAuthenticated) return;

    const lastActivity = localStorage.getItem(LAST_ACTIVITY_KEY);

    if (!lastActivity) {
      updateLastActivity();
    } else {
      const diff = Date.now() - parseInt(lastActivity, 10);
      if (diff > IDLE_TIMEOUT_MS) {
        logout();
        return;
      }
    }

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart"];

    events.forEach((event) =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetTimer)
      );
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };

  }, [isAuthenticated, resetTimer, logout, updateLastActivity]);
};

export default useIdleLogout;